const Link = {
  baseStyle: {
    _focusVisible: { boxShadow: 'outline', borderRadius: 'sm' },
  },
  variants: {
    nav: {
      color: 'text.primary',
      fontWeight: 600,
      _hover: { color: 'accent.default', textDecoration: 'none' },
    },
    footer: {
      color: 'whiteAlpha.900',
      _hover: { color: 'white', textDecoration: 'underline' },
    },
    inline: {
      color: 'accent.default',
      textDecoration: 'underline',
    },
  },
};

export default Link;
